import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useCancelPolicyData } from "../../../lib/useMockData";

export default function NotesSection() {
  const { otherNotes } = useCancelPolicyData();
  return (
    <section className="py-16 md:py-24 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-10">
              <p className="section-label mb-3">{otherNotes.label}</p>
              <h2 className="section-title">{otherNotes.title}</h2>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={150}>
            <div className="bg-airdoa-cream rounded-lg p-6 md:p-8">
              <ul className="flex flex-col gap-4">
                {otherNotes.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <span className="w-5 h-5 flex items-center justify-center text-airdoa-gold shrink-0 mt-0.5">
                      <i className="ri-information-line" />
                    </span>
                    <p className="text-sm text-airdoa-gray leading-relaxed">{item}</p>
                  </li>
                ))}
              </ul>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}